import classNames from 'clsx';

import { EClustersType } from 'shared/map-search/types/clustersType';

import * as styles from './BalloonContent.css';
import { formatBalloonCount } from '../utils';
import { BuildingIcon } from '../../BuildingIcon';
import { BuildingIcon as BuildingIconV2 } from '../../BuildingIconV2';
import { Icon } from '../Icon';
import { Icon as IconV2 } from '../IconV2';

interface IBalloonContentProps {
  count: number;
  price: string;
  isClustersRedesign: boolean;
  isGlow?: boolean;
  isFavorite: boolean;
  hasNewobject?: boolean;
  isActive?: boolean;
  isHovered?: boolean;
  isViewed?: boolean;
  isShowOnlyPrice: boolean;
  pointType: EClustersType | null;
  newbuildingId: number;
  newbuildingText: string;
  hasDiscountOffers?: boolean;
  isAnyFromKp?: boolean;
  isNewbuildingMainPin?: boolean;
  isNewbuildingOnProPlus: boolean;
  isNewbuildingFavorite?: boolean;
  isRedesign: boolean;
}

export const BalloonContent = ({
  count,
  price,
  isClustersRedesign,
  isGlow,
  isFavorite,
  hasNewobject,
  isActive,
  isHovered,
  isViewed,
  isShowOnlyPrice,
  pointType,
  newbuildingId,
  newbuildingText,
  hasDiscountOffers,
  isAnyFromKp,
  isNewbuildingMainPin,
  isNewbuildingOnProPlus,
  isNewbuildingFavorite,
  isRedesign,
}: IBalloonContentProps) => {
  let dataTestId = 'pin';

  if (isNewbuildingMainPin) {
    dataTestId = 'newbuilding-main-pin';
  } else if (isNewbuildingOnProPlus) {
    dataTestId = 'promo-pin';
  }

  const hasIcon = isNewbuildingFavorite || isFavorite || hasDiscountOffers;

  const buildingIcon = isRedesign ? (
    <BuildingIconV2 isActive={isActive || isHovered} isViewed={isViewed} />
  ) : (
    <BuildingIcon isActive={isActive} isViewed={isViewed} />
  );

  const icon = isRedesign ? (
    <IconV2 isFavorite={isFavorite} isPromo={hasDiscountOffers} isActive={isActive || isHovered} isViewed={isViewed} />
  ) : (
    <div className={styles['icon']}>
      <Icon
        isFavorite={isFavorite}
        isPromo={hasDiscountOffers}
        isActive={isActive}
        isViewed={isViewed}
        isRedesign={isClustersRedesign || isRedesign}
        isPromoBalloon
      />
    </div>
  );

  return (
    <div
      data-testid={dataTestId}
      data-newbuilding={newbuildingId}
      data-newbuilding-main-pin={isNewbuildingMainPin || undefined}
      className={classNames({
        [styles['posutochno_wrapper']]: isShowOnlyPrice,
        [styles['wrapper']]: !isShowOnlyPrice,
        [styles['wrapper--redesign']]: isClustersRedesign || isRedesign,
        [styles['wrapper--cluster']]: pointType === EClustersType.OpenablePeas && count > 1,
        [styles['viewed']]: isViewed,
      })}
    >
      <div
        className={classNames(styles['balloon'], {
          [styles['residential-complex']]: hasNewobject || isAnyFromKp,
          [styles['newbuilding--main']]: newbuildingText,
          [styles['colorized']]: isNewbuildingOnProPlus,
          [styles['active']]: isActive,
          [styles['posutochno_balloon']]: isShowOnlyPrice,
          [styles['balloon--redesign']]: isClustersRedesign,
          [styles['balloon--redesign-v2']]: isRedesign,
          [styles['balloon--viewed-single']]: isRedesign && isViewed && count <= 1 && !hasNewobject && !isAnyFromKp,
          [styles['balloon--hovered']]: isHovered && !isActive,
        })}
      >
        {!isNewbuildingMainPin && count > 1 && (
          <div
            className={classNames(styles['count'], {
              [styles['promotion']]: isGlow && !isFavorite && !hasNewobject,
            })}
          >
            {formatBalloonCount(count, isClustersRedesign ? 99 : undefined)}
          </div>
        )}

        {!isNewbuildingMainPin && <div className={styles['price']}>{price}</div>}

        {isNewbuildingMainPin && buildingIcon}
        {isNewbuildingMainPin && <div className={styles['price']}>{newbuildingText}</div>}

        {hasIcon && icon}
      </div>

      {isRedesign && (isHovered || isActive) && (
        <div
          className={classNames(styles['point'], {
            [styles['point--hovered']]: isHovered && !isActive,
            [styles['point--residential-complex']]: hasNewobject || isAnyFromKp,
            [styles['point--cluster']]: pointType === EClustersType.OpenablePeas && count > 1,
            [styles['point--posutochno']]: isShowOnlyPrice,
          })}
        />
      )}
    </div>
  );
};
